import { render, staticRenderFns } from "./CustomersListFilters.vue?vue&type=template&id=2ed214a0"
import script from "./CustomersListFilters.vue?vue&type=script&lang=js"
export * from "./CustomersListFilters.vue?vue&type=script&lang=js"
import style0 from "./CustomersListFilters.vue?vue&type=style&index=0&id=2ed214a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports